import React, { useState, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { RicercaFornitore } from "@/components/RicercaAsync";

// righe: voci della stessa fattura; modifica fornitore / numero / data su tutte insieme
export function ModificaTestataFattura({ righe, onClose, onSaved }) {
  const [f, setF] = useState(null);
  useEffect(() => {
    if (righe?.length) setF({ fornitore_id: righe[0].fornitore_id || "", numero_fattura: righe[0].numero_fattura || "", data: (righe[0].data || "").slice(0, 10) });
  }, [righe]);
  const mut = useMutation({
    mutationFn: async (p) => (await api.put("/materiali/fattura/testata", { ids: righe.map((r) => r.id), ...p })).data,
    onSuccess: (r) => { toast.success(`Fattura aggiornata (${r.aggiornate} voci)`); onSaved(); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  return (
    <Dialog open={!!righe} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="modifica-testata-dialog">
        <DialogHeader><DialogTitle className="font-display">Modifica testata fattura · {righe?.length} voc{righe?.length === 1 ? "e" : "i"}</DialogTitle></DialogHeader>
        {f && (
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5 col-span-2">
              <Label>Fornitore</Label>
              <RicercaFornitore value={f.fornitore_id} onChange={(v) => setF((s) => ({ ...s, fornitore_id: v }))} testid="modifica-testata-fornitore" />
            </div>
            <div className="space-y-1.5"><Label>N. fattura</Label><Input value={f.numero_fattura} onChange={(e) => setF((s) => ({ ...s, numero_fattura: e.target.value }))} data-testid="modifica-testata-numero" /></div>
            <div className="space-y-1.5"><Label>Data</Label><Input type="date" value={f.data} onChange={(e) => setF((s) => ({ ...s, data: e.target.value }))} data-testid="modifica-testata-data" /></div>
            <p className="col-span-2 text-xs text-slate-400">Le modifiche vengono applicate a tutte le voci di questa fattura.</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="modifica-testata-annulla">Annulla</Button>
          <Button onClick={() => f && (f.fornitore_id ? mut.mutate(f) : toast.error("Seleziona il fornitore"))} disabled={mut.isPending} data-testid="modifica-testata-salva">{mut.isPending ? "Salvataggio…" : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
